module.exports = __webpack_public_path__ + "static/media/consolation_spender.a0c7e4af.svg";